module.exports = __webpack_public_path__ + "static/image-symbol-e264d81c39e64033b534d750b26b5e03.jpg";